"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getErrorTranslationId = void 0;
var _types = require("../types");
/**
 * @param originalErrorText Original server error text which is not localized
 * and can be more technical, thus users might not understand it.
 * @returns Translation ID so that a proper translation understandable
 * to the user can be displayed.
 */ const getErrorTranslationId = (originalErrorText)=>{
    if (Object.values(_types.serverErrors).includes(originalErrorText)) {
        return _types.errorTranslationIds[originalErrorText];
    }
    return _types.errorTranslationIds[_types.genericError];
};
exports.getErrorTranslationId = getErrorTranslationId;
